export enum STORAGE_TYPE {
  LOCAL = 1,
  SESSION = 2,
}
